import { useCallback } from 'react';
import useApi from './useApi';
import { useAppSettings } from '../hooks/useAppSettings';

export interface CoatingNote {
    id: number;
    manufacturerId: number;
    manufacturerName: string;
    isGeneralNote: boolean;
    number: string;
    text: string;
    filePath: string;
    lastUpdatedUtc: string;
}

export default () => {
    const { state, getApiData } = useApi();
    const { settings: appSettings } = useAppSettings();

    const getCoatingNotes = useCallback(async () => {
        try {
            const apiUrl = appSettings?.api;
            if (!apiUrl) {
                throw new Error('API URL not configured in app settings');
            }
            await getApiData({
                endpoint: `${apiUrl}/GetCoatingNotes`,
            });
        } catch (error) {
            console.error('Failed to fetch coating notes:', error);
        }
    }, [getApiData, appSettings]);

    const getNotesData = (): CoatingNote[] => {
        if (state.status === 'success' && state.result) {
            let rawData: any[] = [];
            if (Array.isArray(state.result)) {
                rawData = state.result;
            } else if (state.result.data && Array.isArray(state.result.data)) {
                rawData = state.result.data;
            }
            return rawData.map((item) => ({
                id: item.id ?? item.Id,
                manufacturerId: item.manufacturerId ?? item.ManufacturerId,
                manufacturerName: item.manufacturerName ?? item.ManufacturerName ?? '',
                isGeneralNote: item.isGeneralNote ?? item.IsGeneralNote ?? false,
                number: item.number ?? item.Number ?? '',
                text: item.text ?? item.Text ?? '',
                filePath: item.filePath ?? item.FilePath ?? '',
                lastUpdatedUtc: item.lastUpdatedUtc ?? item.LastUpdatedUTC ?? item.LastUpdatedUtc ?? '',
            }));
        }
        return [];
    };

    return {
        coatingNotes: getNotesData(),
        loading: state.isLoading,
        error: state.error,
        getCoatingNotes,
        status: state.status,
    };
};
